import createReducer from 'reducers/createReducer';

import { ShopClientRealTimeControlOptionSetting } from 'actions/actionTypes';

const INITIAL_STATE = { 
    data: {
        paymentType: 1,
        usageTime: 3600,
        isContentLimit: false,
        gameMode: 'Stroke',
        gameTypeLimit: 1,
        gameHoleTypeLimit: 18,
        playerCountLimit: 1,
        drivingRangeTimeLimit: 0,
    },
    error: {
        triggered: false,
        message: ''
    },
};

// 리듀서
const reducer = createReducer(INITIAL_STATE, {
    [ShopClientRealTimeControlOptionSetting.CHANGE_SHOP_CLIENT_REAL_TIME_CONTROL_OPTION_SETTING_INFO]: (state, action) => {
        state.data[action.payload.name] = action.payload.value;
    },

    [ShopClientRealTimeControlOptionSetting.LOAD_SHOP_CLIENT_REAL_TIME_CONTROL_OPTION_SETTING_INFO_REQUEST]: (state, action) => {
        state.error = INITIAL_STATE.error;
    },
    [ShopClientRealTimeControlOptionSetting.LOAD_SHOP_CLIENT_REAL_TIME_CONTROL_OPTION_SETTING_INFO_REQUEST_SUCCESS]: (state, action) => {
        state.data.paymentType = action.payload.paymentType;
        state.data.usageTime = action.payload.usageTime;
        state.data.isContentLimit = action.payload.isContentLimit;

        if(action.payload.isContentLimit === false) {
            state.data.gameMode = 'NoLimit';
        }
        else{
            if(action.payload.gameTypeLimit === 1 || action.payload.gameTypeLimit === 2){
                state.data.gameMode = 'Stroke';
            }
            else if(action.payload.gameTypeLimit === 0 || action.payload.gameTypeLimit === 3 || action.payload.gameTypeLimit === 4 || action.payload.gameTypeLimit === 5){
                state.data.gameMode = 'DrivingRange';
            }
        }

        state.data.gameTypeLimit = action.payload.gameTypeLimit;
        state.data.gameHoleTypeLimit = action.payload.gameHoleTypeLimit;
        state.data.playerCountLimit = action.payload.playerCountLimit;
        state.data.drivingRangeTimeLimit = action.payload.drivingRangeTimeLimit;
    },
    [ShopClientRealTimeControlOptionSetting.LOAD_SHOP_CLIENT_REAL_TIME_CONTROL_OPTION_SETTING_INFO_REQUEST_FAILURE]: (state, action) => {
        state.error = {
            triggered: true,
            message: action.payload
        };
    },

    [ShopClientRealTimeControlOptionSetting.EDIT_SHOP_CLIENT_REAL_TIME_CONTROL_OPTION_SETTING_INFO_REQUEST]: (state, action) => {
        state.error = INITIAL_STATE.error;
    },
    [ShopClientRealTimeControlOptionSetting.EDIT_SHOP_CLIENT_REAL_TIME_CONTROL_OPTION_SETTING_INFO_REQUEST_SUCCESS]: (state, action) => {
    },
    [ShopClientRealTimeControlOptionSetting.EDIT_SHOP_CLIENT_REAL_TIME_CONTROL_OPTION_SETTING_INFO_REQUEST_FAILURE]: (state, action) => {
        state.error = {
            triggered: true,
            message: action.payload
        };
    },
});


export default reducer;